import { useState, useEffect } from 'react'
import { fetchContent } from '../components/product-layout/utils';
import {findImageAndAddPrefix, findLinksAndAddPrefix} from '../lib/transform-utils'
import {isEmpty} from 'lodash'
let markdownWrapper = `{{#markdown}}
  {{markdownBody}}
{{/markdown}}`
export default function useContentCompiler(path, handleBarCompiler, data = {}, isHTMLContent = false, namespace='common') {
    const [content, setContent] = useState(null)
    const [loaded, setLoaded] = useState(false)
    useEffect(()=>{
        (async function () {          
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const content = await fetchContent(path, handleBarCompiler, data, isHTMLContent, namespace)
            setContent(content)
            setLoaded(true);
        })();
    }, []);
    return { content, loaded }
}

export const  getContent = (path, handleBarCompiler, context) => {
    let content = fetchContent(path, handleBarCompiler, context)
    content = findImageAndAddPrefix(content)
    content = findLinksAndAddPrefix(content)
    return content
}

// export const  useHbsCompiler = (template, handleBarCompiler, body = {}, isRef, pageNavigations) => {

//     const [content, setContent] = useState(null)
//     const [loaded, setLoaded] = useState(false)
//     useEffect(()=>{
       
//             if(isRef){
//                 setContent(template(body))
//                 setLoaded(true);
//                 return; 
//             }
//             // const compiledTemplateFn = handleBarCompiler.Handlebars.compile(rawMarkdown, {noEscape: true});
//             const markdownData = template(body);
//             const context = {
//                 markdownBody: new handleBarCompiler.Handlebars.SafeString(markdownData),
//                 ...body
//             }
//             markdownWrapper = markdownWrapper + `
//             ${pageNavigations.nextPageLink && !markdownWrapper.includes("{{nextPageLink}}") ? "{{nextPageLink}}" :""} 
//             ${pageNavigations.seeAlsoLinks && !markdownWrapper.includes("{{seeAlsoLinks}}") ? "{{seeAlsoLinks}}" : "" }
//             `
//             const content = handleBarCompiler.compile(markdownWrapper, context)
//             setContent(content)
//             setLoaded(true);
            
        
//     }, []);
//     return { content, loaded }
// }

export const  useHbsCompiler = (rawBody, frontmatter, location, handleBarCompiler, leftNav, referenceData, pageNavigations) => {

    const [content, setContent] = useState(null)
    const [loaded, setLoaded] = useState(false)
    const [data, setData] = useState({})    
    useEffect(()=>{
          const template = handleBarCompiler.Handlebars.compile(rawBody, {
            noEscape: true,
          })

          const templateData = {
            template,
            attributes: frontmatter,
          }
          
          let context = window.BTHandlebarLib.initialize({ location, templateData })
          context.templateData = templateData
          
          // window.BTHandlebarLib.loadViewModel(context, location.pathname)
          if (context.isDevelopers)
            window.BTHandlebarLib.setDeveloperContext({ location, context, templateData, leftNav })
        
          if (context.isArticles)
            window.BTHandlebarLib.setArticlesContext({ location, context, leftNav })
          
          if (context.isReference && referenceData.data)
            window.BTHandlebarLib.setReferenceContext({ location, context, referenceData })
          
            window.BTHandlebarLib.loadViewModel(context, location.pathname)
            setData(context);
            window.addEventListener('languageSwitch', updateData)
          return function cleanup() {
            window.removeEventListener('languageSwitch', updateData)
          };       
    }, []);

    useEffect(()=>{
      setLoaded(false);
      if(!isEmpty(data)){
        const template = handleBarCompiler.Handlebars.compile(rawBody, {
          noEscape: true,
        })
  
        if(referenceData.isRef){
          setContent(template(data))
          setLoaded(true);
          return; 
      }
      // const compiledTemplateFn = handleBarCompiler.Handlebars.compile(rawMarkdown, {noEscape: true});
      const markdownData = template(data);            
      
      const hbsContext = {
          markdownBody: new handleBarCompiler.Handlebars.SafeString(markdownData),
          ...data
      }
      
      markdownWrapper = markdownWrapper + `
      ${pageNavigations.seeAlsoLinks && !markdownWrapper.includes("{{seeAlsoLinks}}") ? "{{seeAlsoLinks}}" : "" }
      ${pageNavigations.nextPageLink && !markdownWrapper.includes("{{nextPageLink}}") ? "{{nextPageLink}}" :""}`
  
      const content = handleBarCompiler.compile(markdownWrapper, hbsContext)            
      setContent(content)
      setTimeout(()=>setLoaded(true), 0)
      }

    },[data])

    function updateData(data){
      setData((oldContext)=> {return {...oldContext, ...data.detail}})
    }
    return { content, loaded, data }
}